import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=26f828fc"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f828fc')) {
      api.createRecord('26f828fc', component.options)
    } else {
      api.reload('26f828fc', component.options)
    }
    module.hot.accept("./Questions.vue?vue&type=template&id=26f828fc", function () {
      api.rerender('26f828fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/Questions.vue"
export default component.exports